/*
	Javascript for a charity's payment details list/submit page
	@author Matthew Norris
*/

import PaymentDetailsEdit from 'Scripts/admin/payment-details-edit';

export default class PaymentDetails {
	constructor() {
		const paymentDetailsEdit = new PaymentDetailsEdit({
			isCharity: true,
			onComplete: function() {
				window.location.href = "/finance/payment-details/";
			},
			postEndpoint: "/finance/payment-details-submit"
		});

		let type = window.location.href;
		type = type.substring(type.lastIndexOf("/") + 1);

		console.log("PaymentDetails()", type);

		paymentDetailsEdit.type = type;
		paymentDetailsEdit.setupForm();
	}
}